export const VIEWER_VERSION_CHECK_URL = "https://storage.googleapis.com/knsh-update-storage/j/viewer/pc/version.json";
export const BOOK_CHECK_BASE_URL = "https://storage.googleapis.com/knsh-update-storage/";